module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/nomination-day-form-submissions.jpg?v=052dc5e2";